import Box from '@mui/material/Box';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { SxProps, Theme } from '@mui/material/styles';
import type { ComponentType, ReactNode } from 'react';
import { getChipSx } from './OpenXAgentChip.styles';

type OpenXAgentChipProps = {
  children: ReactNode;
  icon?: ComponentType<SvgIconProps> | undefined;
  component?: 'span' | 'li';
  sx?: SxProps<Theme>;
  'data-test'?: string;
};

export const OpenXAgentChip = ({ children, icon: Icon, component = 'span', sx = [], ...rest }: OpenXAgentChipProps) => (
  <Box component={component} {...rest} sx={[getChipSx(Boolean(Icon)), ...(Array.isArray(sx) ? sx : [sx])]}>
    {Icon ? <Icon sx={{ fontSize: 16 }} /> : null}
    <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
      {children}
    </Box>
  </Box>
);
